import { render, staticRenderFns } from "./RemoveGameList.vue?vue&type=template&id=3522ba9d&scoped=true&"
import script from "./RemoveGameList.vue?vue&type=script&lang=js&"
export * from "./RemoveGameList.vue?vue&type=script&lang=js&"
import style0 from "./RemoveGameList.vue?vue&type=style&index=0&id=3522ba9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522ba9d",
  null
  
)

export default component.exports